import React, { memo } from 'react';
import { CLIP_SKELETON_WIDTH_PX } from '@src/constants/timeline';
import { StyledClipSkeleton, StyledTextBar } from './index.style';

/**
 * Placeholder clip for a block that hasn't arrived yet — shown on the voice
 * lane while transcript extraction streams blocks in. Purely decorative: it
 * carries no block id and takes no pointer input, so it can never be selected,
 * trimmed or moved.
 */
const ClipSkeleton = memo(({ left = 0, width = CLIP_SKELETON_WIDTH_PX }) => (
  <StyledClipSkeleton left={left} width={width} aria-hidden="true">
    <StyledTextBar />
  </StyledClipSkeleton>
));

export default ClipSkeleton;
